import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AdminSetCrimsonCommand } from '../_models/_commands/admin/adminCommands';
import { Personnage } from '../_models/personnage';
import { AdminDesinscriptionCommand } from '../_models/_commands/admin/adminDesinscriptionCommand';
import { AdminPersonnageAddCompetenceCommand, AdminPersonnageAddSortCommand, AdminPersonnageInfoCommand, AdminPersonnageRemoveCompetenceCommand, AdminPersonnageRemoveSortCommand, AdminPersonnageSupprimerCommand } from '../_models/_commands/admin/adminPersonnageCommands';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient) { }


  listPersonnage() {
    return this.http.get<any[]>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_List`);
  }

  getPersonnage(id: number) {
    var params = new HttpParams({fromString: `id=${id}`});
    return this.http.get<Personnage>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_Get`, {params: params});
  }

  dataDumpPersonnage() {
    return this.http.get<any[]>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_DataDumpPersonnage`);
  }

  setPersonnageCrimson(command: AdminSetCrimsonCommand) {
    return this.http.post<Personnage>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_SetCrimson`, command);
  }

  desinscription(command: AdminDesinscriptionCommand) {
    return this.http.post<Personnage>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_Desinscription`, command);
  }

  listReports() {
    return this.http.get<string[]>(`${environment.apiUrl}/api/MgmtLogFunctions_ListReports`);
  }

  listAdminLog() {
    return this.http.get<string[]>(`${environment.apiUrl}/api/MgmtLogFunctions_ListAdminLog`);
  }
  

  addCompetence(command: AdminPersonnageAddCompetenceCommand) {
    return this.http.post<Personnage>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_AddCompetence`, command);
  }

  removeCompetence(command: AdminPersonnageRemoveCompetenceCommand) {
    return this.http.post<Personnage>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_RemoveCompetence`, command);
  }

  addSort(command: AdminPersonnageAddSortCommand) {
    return this.http.post<Personnage>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_AddSort`, command);
  }

  removeSort(command: AdminPersonnageRemoveSortCommand) {
    return this.http.post<Personnage>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_RemoveSort`, command);
  }

  changeInfo(command: AdminPersonnageInfoCommand) {
    return this.http.post<Personnage>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_Info`, command);
  }

  deletePersonnage(command: AdminPersonnageSupprimerCommand) {
    return this.http.post<Personnage>(`${environment.apiUrl}/api/MgmtPersonnageFunctions_Delete`, command);
  }
}
